import { gql } from '@apollo/client';

export const watchSurveyGroupChangesSubscription = gql`
  subscription WatchSurveyGroupChanges($surveyGroupId: ID!) {
    watchSurveyGroupChanges(surveyGroupId: $surveyGroupId) {
      surveyGroupId
    }
  }
`;

export const arielAiChatSubscription = gql`
  subscription ArielAiChat(
    $topicId: ID!
    $languageCode: String!
    $messages: [ArielAiChatMessageInput!]!
    $graph: [ArielAiNodeDataInput!]!
  ) {
    arielAiChat(topicId: $topicId, languageCode: $languageCode, messages: $messages, graph: $graph) {
      text
      done
      patch {
        questionIndex
        questionText
        isRequired
        metrics
        isQuestionTrigger
        choices {
          key
          value
        }
        statements
        statementIds
        randomizeOrder
        isRankingScale
        showEscapeOption
        type
        range {
          min
          max
        }
        answersToHighlight {
          key
          value
        }
        input
        outputs {
          key
          targetQuestionIndex
        }
        position
        reportOrder
        comments {
          id
          text
          originator
        }
        commentGroupId
      }
      error {
        code
        message
        validationErrors
      }
    }
  }
`;
